import BaseAPIService from '@/services/baseAPIService'

export default class CoreAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Labels
  getLabels()               { return this.httpClient.get(`/labels`) }
  getLabelsForType(type)    { return this.httpClient.get(`/labels?type=${type}`) }
  updateLabel(id, data)     { return this.httpClient.put(`/labels/${id}`, data) }
  createLabel(data) { return this.httpClient.post(`/labels`, data) }
  deleteLabel(id) { return this.httpClient.delete(`/labels/${id}`) }
  restoreLabelsForType(type) { return this.httpClient.put(`/labels/restore?type=${type}`) }

  // User Files
  createUserFile(data) { return this.httpClient.post(`/files`, data) }
  getUserFiles(linkType, linkId) { return this.httpClient.get(`/files?linkType=${linkType}&linkId=${linkId}`) }
  deleteUserFile(id) { return this.httpClient.delete(`/files/${id}`) }

  // Uploader - Direct-to-S3 multipart uploader used by FormUpload
  createS3MultipartUpload(data)                   { return this.httpClient.post(`/system/upload/s3/multipart`, data) }
  listS3MultipartUploadParts(s3UploadId, data)    { return this.httpClient.post(`/system/upload/s3/multipart/${s3UploadId}/list`, data) }
  prepareS3MultipartUploadPart(s3UploadId, data)  { return this.httpClient.post(`/system/upload/s3/multipart/${s3UploadId}/prepare`, data) }
  abortS3MultipartUploadPart(s3UploadId, data)    { return this.httpClient.post(`/system/upload/s3/multipart/${s3UploadId}/abort`, data) }
  completeS3MultipartUpload(s3UploadId, data)     { return this.httpClient.post(`/system/upload/s3/multipart/${s3UploadId}/complete`, data) }
  deleteS3MultipartUpload(data)                   { return this.httpClient.post(`/system/upload/s3/multipart/delete`, data) }

  // Logo Images
  updateLogoImage(id, resource, logoTypeName, data) { 
    if(id === null)
      return this.httpClient.put(`/${resource}/${logoTypeName}`, data)
    return this.httpClient.put(`/${resource}/${id}/${logoTypeName}`, data)
  }
  deleteLogoImage(id, resource, logoTypeName = 'logo') {
    if(id === null)
      return this.httpClient.delete(`/${resource}/${logoTypeName}`)
    return this.httpClient.delete(`/${resource}/${id}/${logoTypeName}`)
  }

  // Integrations
  getIntegrationConnectLink(code) { return this.httpClient.get(`/integrations/${code}/connect`) }
  connectIntegration(code, data) { return this.httpClient.post(`/integrations/${code}/connect`, data) }
  disconnectIntegration(code) { return this.httpClient.post(`/integrations/${code}/disconnect`) }

  // Currency
  getCurrencyList()         { return this.httpClient.get(`/currency`) }
  getCurrencyExchangeRate(currencyCode) { return this.httpClient.get(`/currency/exchange/${currencyCode}`) }

  // Barcode
  runBarcodeLookup(barcode)     { return this.httpClient.get(`/barcodes/lookup?barcode=${encodeURIComponent(barcode)}`) }

  // Comments
  createComment(data)           { return this.httpClient.post(`/activityitems/comment`, data) }
  createReplyComment(id, data)  { return this.httpClient.post(`/activityitems/${id}/comment`, data) }
  deleteComment(id)             { return this.httpClient.delete(`/activityitems/${id}`) }

  // Notifications
  flagNotificationRead(id)      { return this.httpClient.post(`/communication/notifications/${id}/read`) }

  // Profile
  getProfileMenu()              { return this.httpClient.get(`/profile/menu`) }

  // Dashboard
  getDashboardPendingItemList() { return this.httpClient.get(`/dashboard/pendingitems`) }
  getDashboardSummary()         { return this.httpClient.get(`/dashboard/summary`) }

  // Permission Types
  getPermissionTypes()          { return this.httpClient.get(`/permissiontypes`) }

  // DXF - Conversion
  convertDXFFile(data)          { return this.httpClient.post(`/dxf/convert`, data) }

  // Account Onboarding - Invitation
  authenticateAccountInvitation(data)    { return this.httpClient.post(`/account/invitation/complete`, data) }
}
